<template>
  <div>
    <div class="title row text-center py-3"><h2 id="analysis-title-h1" class="col font-weight-bold">選擇你要的地區</h2></div>
    <transition name="fade">
      <div id="location-buttons" class="row" v-if="!active && currentLocation != null">
        <div class="panel-toggler">
          <template>
            <ul class="list-group list-group-horizontal border-top-0">
              <li class="list-group-item list-group-item-action btn text-center" @click="cancelLocation()">重新選擇地區</li>
              <li class="list-group-item list-group-item-action btn text-center" @click="active = true">查看{{currentLocation.name}}資料庫</li>
            </ul>
          </template>
        </div>
      </div>
    </transition>
    <div id="analysis-app" :class="{ active: panelOpened }">
      <div>
        <ul class="list-group list-group-horizontal border-top-0 panel-toggler" v-if="active && currentLocation != null">
          <li class="list-group-item list-group-item-action btn text-center" @click="cancelLocation()">重新選擇地區</li>
          <li class="list-group-item list-group-item-action btn text-center" @click="active = false">縮小{{currentLocation.name}}資料庫</li>
        </ul>
        <div id="analysis-panel" class="px-3 py-0">
          <nav class="tab-buttons px-2 row d-none d-lg-flex">
            <div :class="['tab-button dashboard col', { active: currentTab === '儀表板' }]" @click="changeTab('儀表板')">
              <img :class="['tab-image mb-1', { active: currentTab === '儀表板' }]" v-bind:src="tabImages['dashboard-chosen']" v-if="currentTab === '儀表板'">
              <img :class="['tab-image mb-1', { active: currentTab === '儀表板' }]" v-bind:src="tabImages['dashboard-normal']" v-if="currentTab !== '儀表板'">
              <div class="tab-zh text-truncate">儀表板</div>
              <div class="tab-en text-truncate">Dashboard</div>
            </div>
            <div
              v-for="tab in tabs"
              :key="tab"
              :class="['tab-button col', { active: currentTab === tab }]"
              @click="changeTab(tab)"
            >
              <img :class="['tab-image mb-1', { active: currentTab === tab }]" v-bind:src="tabImages[tabImageMapping[tab]]">
              <div class="tab-zh text-truncate">{{ tab }}</div>
              <div class="tab-en text-truncate">{{ tabEn[tab] }}</div>
            </div>
          </nav>
          <div class="row my-3 mx-1 d-lg-none">
            <div class="col-2 pl-0">
              <a href="#" @click="changeTab('儀表板')" v-show="currentTab != '儀表板'">
                <img src="../../assets/images/arrow-left.svg" style="width: 48px;" title="儀表板">
              </a>
            </div>
            <div class="col-8">
              <div class="h4 font-weight-bold text-center py-2">{{ currentTab }}</div>
            </div>
            <div class="col-2"></div>
          </div>
          <div id="panel-content">
            <Dashboard
              v-show="currentTab == '儀表板'"
              :categs="categs"
              :countyList="countyList"
              :townList="townList"
              :location="currentLocation"
              :tabImages="tabImages"
              @changeTab="changeTab" />
            <AnalysisCategs
              v-if="currentTab != '儀表板'"
              :countyList="countyList"
              :townList="townList"
              :location="currentLocation"
              :currentTab="currentTab"
              :categ="currentCateg"
              :indexCompare="indexCompare"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Dashboard from "./dashboard.vue";
import AnalysisCategs from "./analysis-categs.vue";

export default {
  components: {
    Dashboard,
    AnalysisCategs,
  },
  created() {
    this.axios
      .get("categs12")
      .then((resp) => {
        this.categs = resp.data;
      })
      .catch((err) => {
        console.log(err);
      });

    this.getCountyList();
    this.getTownList();
    this.testlocation();

    this.$root.$on("retract_panel", () => {
      this.active = false;
    });
  },
  mounted() {
    $("#county").change(() => {
      if ($("#county").val() != null && $("#county").val() != "00000") {
        let county = this.findCounty($("#county").val());
        this.location.county.name = county.county;
        this.location.county.id = county.county_id_n;
        this.location.town.name = "";
        this.location.town.id = null;
      } else {
        this.location.county.name = "";
      }
    });

    $("#town").change(() => {
      if ($("#town").val() != null && $("#town").val() != "00000000") {
        let town = this.findTown($("#town").val());
        this.location.town.name = town.town;
        this.location.town.id = town.town_id_n;
      } else {
        this.location.town.name = "";
      }
    });

    if (this.location && this.location.county && this.location.county.name) {
      document.querySelector("#analysis-title-h1").textContent =
        this.location.county.name + " " + this.location.town.name;
      //document.querySelector('#analysis-title-p').textContent = ''
    }

    $("#wmtslist").val("[]");
  },
  data() {
    return {
      categs: [],
      countyList: [],
      townList: [],
      active: false,
      location: {
        county: {
          name: "",
          id: null,
        },
        town: {
          name: "",
          id: null,
        },
      },
      // two way binding v-model: currentTab
      currentTab: "儀表板",
      tabs: [
        "人口",
        "所得",
        "經濟與產業",
        "交通",
        "觀光",
        "土地",
        "住宅",
        "環境",
        "教育",
        "文化",
        "社福",
        "醫療",
      ],
      tabImageMapping: {
        人口: "pop",
        所得: "income",
        經濟與產業: "econ_indus",
        交通: "transp",
        觀光: "tourism",
        土地: "land",
        住宅: "house",
        環境: "environ",
        教育: "edu",
        文化: "culture",
        社福: "welfare",
        醫療: "med",
      },
      tabEn: {
        人口: "Population",
        所得: "Income",
        經濟與產業: "Economy and Industry",
        交通: "Transportation",
        觀光: "Tourism",
        土地: "Land",
        住宅: "Housing",
        環境: "Environment",
        教育: "Education",
        文化: "Culture",
        社福: "Social Welfare",
        醫療: "Medical",
      },
      tabImages: {
        "dashboard-normal": require("../../assets/images/6-analysis/icon-indicators-dashboard-normal.svg"),
        "dashboard-chosen": require("../../assets/images/6-analysis/icon-indicators-dashboard-chosen.svg"),
        culture: require("../../assets/images/6-analysis/icon-indicators-culture.svg"),
        econ_indus: require("../../assets/images/6-analysis/icon-indicators-econ_indus.svg"),
        edu: require("../../assets/images/6-analysis/icon-indicators-edu.svg"),
        environ: require("../../assets/images/6-analysis/icon-indicators-environ.svg"),
        house: require("../../assets/images/6-analysis/icon-indicators-house.svg"),
        income: require("../../assets/images/6-analysis/icon-indicators-income.svg"),
        land: require("../../assets/images/6-analysis/icon-indicators-land.svg"),
        med: require("../../assets/images/6-analysis/icon-indicators-med.svg"),
        pop: require("../../assets/images/6-analysis/icon-indicators-pop.svg"),
        tourism: require("../../assets/images/6-analysis/icon-indicators-tourism.svg"),
        transp: require("../../assets/images/6-analysis/icon-indicators-transp.svg"),
        welfare: require("../../assets/images/6-analysis/icon-indicators-welfare.svg"),
      },
    };
  },
  methods: {
    testlocation() {
      //this.location.county.name = "臺北市"
      //this.location.county.id = "63000"
      //this.location.town.name = "南港區"
      //this.location.town.id = "63000090"
      //$('#searchmyloc').click();
    },
    cancelLocation() {
      $("#selectloc").click();
      this.currentTab = "儀表板";
      this.active = false;
      // this.location.county.name = "";
      // this.location.town.name = "";
    },
    getDataset(subcateg) {
      return this.currentCateg.subcategs.filter((x) => x.id == subcateg)[0]
        .table_prefix;
    },
    getMinscl(subcateg) {
      return this.currentCateg.subcategs.filter((x) => x.id == subcateg)[0]
        .minscl;
    },
    getCountyList() {
      this.axios
        .get("countybbox")
        .then((resp) => {
          this.countyList = resp.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTownList() {
      this.axios
        .get("townbbox")
        .then((resp) => {
          this.townList = resp.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    findCounty(county_id) {
      return this.countyList.filter((x) => x.county_id_n == county_id)[0];
    },
    findTown(town_id) {
      return this.townList.filter((x) => x.town_id_n == town_id)[0];
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
  },
  computed: {
    panelOpened() {
      return this.active && this.currentLocation != null;
    },
    currentLocation() {
      if (this.location.county.name.length == 0) return null;

      if (this.location.town.name.length > 0) {
        return {
          type: "town",
          name: this.location.town.name,
          id: this.location.town.id,
          countyname: this.location.county.name,
          countyid: this.location.county.id,
        };
      } else {
        return {
          type: "county",
          name: this.location.county.name,
          id: this.location.county.id,
          countyname: this.location.county.name,
          countyid: this.location.county.id,
        };
      }
    },
    locationCounty() {
      return this.location.county;
    },
    currentCateg() {
      if (this.currentTab == "儀表板") return null;

      return this.categs.filter((x) => x.title == this.currentTab)[0];
    },
    indexCompare() {
      return this.currentCateg.topstats.map((x) => {
        x.dataset = this.getDataset(x.subcateg);
        x.minscl = this.getMinscl(x.subcateg);
        return x;
      });
    },
  },
  watch: {
    location: {
      handler: function() {
        if (this.location.town.id != "00000000") {
          this.active = true;
        }
        if (this.currentLocation != null) {
          var locationname = this.location.county.name;
          if (this.location.town.name.length > 0) {
            locationname = locationname + this.location.town.name;
          }
          $("#analysis-title-h1").text(locationname);
        } else {
          $("#analysis-title-h1").text("選擇你要的地區");
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/custom_var";
@import "../../css/custom_mixin";
$panel-width: 100%;
//$panel-width: min(90vw, 1100);

#analysis-app {
  position: absolute;
  left: -$panel-width;
  // top: 50;
  height: 95vh;
  z-index: 5;
  width: 100%;
  background: $ts-orange-4th;
  @include transition(all 0.1s ease-in);

  &.active {
    left: 0;
  }
}

#location-buttons {
  border-bottom-style: solid;
  border-right-style: solid;
  border-color: #f2ddbf;
  border-width: 0.5px;
  z-index: 10;
  & > div {
    img {
      width: 10px;
      height: 10px;
      // margin-bottom: 10px;
    }

    // span {
    //   writing-mode: vertical-lr;
    // }
  }
}

.close-button {
  & > img {
    width: 20px;
    height: 20px;
  }
}

#cancel-location {
  background: $ts-orange-3rd;
  width: 100%;
}

.panel-toggler {
  background: $ts-orange-4th;
  width: 100%;
}

#analysis-panel {
  background: $ts-orange-4th;
  width: 100%;
}

.tab-buttons {
  .tab-button.dashboard {
    color: $ts-orange !important;
    &.active {
      color: $ts-orange-4th !important;
    }
  }

  .tab-button {
    height: 97px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: $ts-orange-4th;
    border-width: 2px;
    border-bottom-color: $ts-orange;
    text-align: center;
    font-weight: 500;
    padding-top: 5px;
    .tab-en {
      font-size: 10px;
    }
    .tab-zh {
      font-size: 15px;
    }
    &.active {
      border-color: $ts-orange !important;
      background: $ts-orange !important;
      color: black !important;
    }
  }

  .tab-button:hover {
    color: black;
    background-color: $ts-orange-3rd;
  }

  img {
    width: 50px;
    height: 50px;
    // margin-bottom: 5px;
  }
}

#panel-content {
  /*??*/
  /*margin-right: 125px;*/
}
</style>
